import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';

const TableCol = ({ data }) => {
  return (
    <TableContainer component={Paper} width="1px">
      <Table size="small" aria-label="simple table">
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {row.label}
              </TableCell>
              <TableCell align="right">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableCol;

